import { apiProxyUrl } from '../../utils/apiProxy';

/**
 * OpenWeather's current conditions at a hike's start, `[lng, lat]` as the card holds it, through
 * our proxy so the key stays server-side. Metric, as fromOWM expects.
 */
export function currentWeatherUrl(lng: number, lat: number): string {
  const query = new URLSearchParams({ lat: lat.toString(), lon: lng.toString(), units: 'metric' }).toString();
  return apiProxyUrl('openweather', 'weather', query);
}
